import axios from 'axios'
import { environment } from '@/data/environment/'

function downloadFile (response, fileName) {
  const url = window.URL.createObjectURL(
    new Blob([response.data]),
  )

  const link = document.createElement('a')

  link.href = url

  link.setAttribute('download', fileName)

  document.body.appendChild(link)

  link.click()

  link.remove()

  window.URL.revokeObjectURL(url)
}
export default {

  namespaced: true,

  state: {
    configs: [], terminals: [], statusResponse: false,
  },

  mutations: {

    setConfigs (state, data) {
      state.configs = data
    },

    setTerminals (state, data) {
      state.terminals = data
    },

    setStatusResponse (state, data) {
      state.statusResponse = data
    },

  },

  actions: {

    /**
     * Configuración General
     */
    getConfigs ({ commit }) {
      const endpoint = '/api/puntos-colombia/config'

      const url = environment.HIOPOSWEBSERVICES + endpoint

      axios
        .create()
        .get(url)
        .then(response => {
          commit('setConfigs', response.data.data)
        })
        .catch(function (error) {
          console.log(error.message)
        })
    },

    saveConfig ({ commit }, formData) {
      const endpoint = '/api/puntos-colombia/config'

      const url = environment.HIOPOSWEBSERVICES + endpoint

      return axios
        .create()
        .post(url, formData, {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
        })
        .then(response => {
          commit('setStatusResponse', response.data)

          return response
        })
    },

    /**
     * Terminales
     */
    getTerminals ({ commit }, idCompania) {
      const endpoint = '/api/puntos-colombia/terminal/' + idCompania

      const url = environment.HIOPOSWEBSERVICES + endpoint

      axios
        .create()
        .get(url)
        .then(response => {
          commit('setTerminals', response.data.data)
        })
        .catch(function (error) {
          console.log(error.message)
        })
    },

    saveTerminal ({ commit }, data) {
      const endpoint = '/api/puntos-colombia/terminal'

      const url = environment.HIOPOSWEBSERVICES + endpoint

      return axios
        .create()
        .post(url, data)
    },

    changeStatus ({ commit }, data) {
      const endpoint =
        '/api/puntos-colombia/terminal/status'

      const url =
        environment.HIOPOSWEBSERVICES +
        endpoint

      return axios
        .create()
        .put(url, data)
    },

    downloadAuditLogs (context, payload) {
      return axios({

        url:
          environment.HIOPOSWEBSERVICES +
          '/api/puntos-colombia/audit/logs/' +
          payload.company.IdCompania,

        method: 'GET',

        params: {
          from: payload.from,
          to: payload.to,
        },

      }).then(response => {
        downloadFile(
          {
            data: JSON.stringify(response.data, null, 2),
          },
          `puntos_colombia_logs_${payload.from}_${payload.to}.json`,
        )
      })
    },

    downloadAuditReport (context, payload) {
      return axios({

        url:
          environment.HIOPOSWEBSERVICES +
          '/api/puntos-colombia/audit/report/' +
          payload.company.IdCompania,

        method: 'GET',

        responseType: 'blob',

        params: {
          from: payload.from,
          to: payload.to,
        },

      }).then(response => {
        downloadFile(
          response,
          `puntos_colombia_reporte_${payload.from}_${payload.to}.xlsx`,
        )
      })
    },

  },

}
